import { createSlice } from '@reduxjs/toolkit';

type IData = {
  pin: string;
  surname: string;
  name: string;
  patronym: string;
  gender: string;
  is_alive: boolean;
  date_of_birth: string;
  birth_country: {
    id: number;
    name: string;
  };
  birth_place: {
    id: number;
    name: string;
  };
  nationality: {
    id: number;
    name: string;
  };
  citizenship: {
    id: number;
    name: string;
  };
  document: {
    series_number: string;
    validity_period_begin: string;
    validity_period_end: string;
    issued_by: {
      id: number;
      name: string;
    };
  };
};

type RequestCommandState = {
  loading: boolean;
  data: IData;
};

let data;

const initialState: RequestCommandState = {
  loading: false,
  data,
};

export const personInfosSlice = createSlice({
  name: 'integrationsPersonInfos',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export default personInfosSlice.reducer;
